import { AfterViewInit, Component, EventEmitter, Inject, Input, NgZone, OnInit, Output, Renderer2 } from '@angular/core';
import { ResponseService, WindowRef } from '@portals/core';
import { NotificationsResponseComponent } from '../notifications-response';
import { HotToastService } from '@ngneat/hot-toast';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie';
import { CollectiblesState } from '@portals/store';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AWSUploadService, Channel, Notification, ThemeType } from '@portals/api';
import { fadeIn, fadeIn1, fadeOut, RESPONSE_TYPES } from '@portals/utils';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'portals-text-response',
	templateUrl: './text-response.component.html',
	styleUrls: ['./text-response.component.scss'],
	animations: [fadeIn, fadeIn1, fadeOut],
})
export class TextResponseComponent extends NotificationsResponseComponent implements AfterViewInit {
	@Input() override notification!: Notification;
	@Input() override channel!: Channel;
	@Input() override activeScreen!: RESPONSE_TYPES;
	@Input() override response = '';
	@Input() override typeReady = false;
	@Input() override startTyping = false;
	@Input() override typingMode = false;
	@Input() override finishedResponding = false;
	@Output() setActiveScreen: EventEmitter<RESPONSE_TYPES> = new EventEmitter<RESPONSE_TYPES>();
	@Output() closeModal = new EventEmitter<any>();
    currentLanguage = 'en';
	theme?: ThemeType;
	constructor(protected override ngZone: NgZone, public translate: TranslateService, protected override toast: HotToastService, protected override location: Location, protected override router: Router, protected override cookies: CookieService, protected awsUpload: AWSUploadService, protected override collectibleState: CollectiblesState, protected override renderer: Renderer2, protected override deviceService: DeviceDetectorService, protected override window: WindowRef, protected override responseService: ResponseService) {
		super(ngZone, toast, location, router, cookies, awsUpload, collectibleState, renderer, deviceService, window, responseService);
		/* Set states for streaming */
		super.mediaConstraints = {
			video: false,
			audio: false,
		};

        // Localization stuff
        const systemDefaultLanguage = navigator.language.split('-')[0];
        const supportedLanguages = ['en', 'es', 'ar']; // Add more languages as needed
        const defaultLanguage = supportedLanguages.includes(systemDefaultLanguage) ? systemDefaultLanguage : 'en';
        translate.setDefaultLang(defaultLanguage);
        this.currentLanguage = systemDefaultLanguage;

        if (this.notification?.localization) {
            this.currentLanguage = this.notification.localization;
            this.customLocalizationSet = true;
            translate.setDefaultLang(this.notification.localization);
        }
	}

	ngAfterViewInit(): void {
		this.audioMode = true;
		this.theme = this.channel.links?.theme;
		super.initView();
	}
	getBackgroundColorClass() {
		if (this.theme && this.theme.background_color) {
			return { background: this.theme.background_color, 'background-color': this.theme.background_color };
		} else {
			// return { background: '#491176' };
			return {
				'background-color': 'transparentize(#180225, 0.1)',
			};
		}
	}
}
